interface TokenData {
    jwt: string;
}

/**
 * Retrieves the JWT string from localStorage.
 * Throws if the user is not logged in.
 */
export const getJWT = (): string => {
    const tokenJson = localStorage.getItem('token');
    if (!tokenJson) {
        throw new Error('Not logged in');
    }
    const token: TokenData = JSON.parse(tokenJson);
    return token.jwt;
};
